/**
 * @param {number?} money - money float
 *
 * @returns {string} formatted money
 */
export function formatMoney(money) {
  if (!money) return null;

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(money);
}
